<template>
  <div>
    <FormLayout
      :tabs="this.tabs"
      :leftAction="this.leftAction"
      :onChangeTab="onChangeTabIndex"
    ></FormLayout>
  </div>
</template>

<script>
import Vue from "vue";
import FormLayout from "../../../layouts/FormLayout.vue";
import RoutesPaths from "../../../router/router-structure/routes-paths";

Vue.component("link-certification-form", () =>
  import("./LinkCertificationTrainingForm.vue")
);

export default {
  components: {
    FormLayout,
  },
  async mounted() {
    if (this.$route.params.id) {
      this.leftAction.text = "Editar Vínculo";
    }
  },
  data: function () {
    return {
      currentTabIndex: 0,
      leftAction: {
        text: "Novo Vínculo",
        onClick: this.leftActionClickHandler,
      },
      leftLinkNavigation: this.leftHistoryNavigation,

      tabs: [
        {
          title: "Informações Gerais",
          formComponent: "link-certification-form",
        },
      ],
    };
  },
  methods: {
    onChangeTabIndex(newValue) {
      this.currentTabIndex = newValue;
    },
    leftActionClickHandler() {
      this.$router.push(
        RoutesPaths.linkCertificationTrainingManagement.rootName()
      );
    },
    leftHistoryNavigation() {
      this.$router.push({
        path: RoutesPaths.requestHistory.rootName(),
        params: {
          serviceType: this.tabs[this.currentTabIndex].serviceType,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
